import React from 'react';
import { Text } from '@mantine/core';
import {
  CAROUSEL_STYLE_PRESETS,
  carouselStylePatch,
} from './carouselStyles';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import ThemeStyleGallery from '../../../puck/fields/ThemeStyleGallery';
import StyleCardPreview from '../../../theme/StyleCardPreview';
import styles from './CarouselStylePicker.module.css';

/**
 * Galerie de styles de carrousel. Un style est un JEU DE VALEURS, pas une
 * variante.
 * Les génériques sont des COPIES : en cliquer un recopie ses valeurs dans le
 * bloc, qui reste « Personnalisé » (aucun n'est jamais surligné). Seul un
 * style du thème se suit (cf. ThemeStyleGallery).
 *
 * Le champ est déclaré sur `loop` — la seule prop de style que la sidebar
 * n'éditait pas déjà. Puck indexe ses champs par nom de prop : il fallait une
 * clé libre pour héberger le sélecteur, qui écrit de toute façon TOUTES les
 * props de style par dispatch. Même arrangement que `titleStyle` sur la Carte
 * info.
 */
export default function CarouselStylePicker() {
  const { updateItemProps } = useSelectedItemProps();

  return (
    <ThemeStyleGallery kind="carousel" classes={styles}>
      <div className={styles.grid} role="listbox" aria-label="Style du carrousel">
        {CAROUSEL_STYLE_PRESETS.map((def) => (
          <button
            key={def.key}
            type="button"
            role="option"
            aria-selected={false}
            title={def.label}
            className={styles.card}
            // Un seul dispatch : le style pose toutes ses props d'un coup, donc
            // une seule entrée d'historique et un seul patch autosave.
            onClick={() => updateItemProps({ ...carouselStylePatch(def), themeStyleId: null })}
          >
            <StyleCardPreview kind="carousel" values={def.props} />
            <Text size="10px" c="dimmed" lh={1.2} ta="center">
              {def.label}
            </Text>
          </button>
        ))}
      </div>
    </ThemeStyleGallery>
  );
}
